<teleport to="body">
  <div
    v-if="visible"
    class="modal fade show d-block"
    tabindex="-1"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered onboarding-user-profile-modal-dialog" @click.self="close_modal">
      <div class="modal-content border-0 shadow-lg overflow-hidden onboarding-user-profile-modal-content">
        <div class="onboarding-user-profile-modal-header d-flex align-items-center justify-content-between gap-3">
          <h2 class="h5 fw-bold text-white mb-0">My Profile</h2>
          <button
            type="button"
            class="btn btn-link text-white text-decoration-none p-0 onboarding-user-profile-close"
            aria-label="Close profile"
            @click="close_modal"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="onboarding-user-profile-modal-body">
          <div v-if="is_loading" class="d-flex align-items-center justify-content-center py-5">
            <div class="spinner-border text-secondary me-3" role="status" aria-hidden="true"></div>
            <span class="text-muted fw-semibold">Loading profile...</span>
          </div>

          <div v-else-if="error" class="alert alert-warning mb-0">
            {{ error }}
          </div>

          <template v-else-if="profile">
            <section class="onboarding-user-profile-hero cards-border-color">
              <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                <div class="d-flex align-items-start gap-3 min-w-0">
                  <div class="onboarding-user-profile-avatar d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0">
                    {{ profile.initials }}
                  </div>
                  <div class="min-w-0">
                    <div class="onboarding-user-profile-name text-truncate">{{ profile.display_name }}</div>
                    <div class="onboarding-user-profile-email text-truncate">{{ profile.email }}</div>
                  </div>
                </div>

                <div class="d-flex align-items-start gap-2">
                  <button
                    v-if="can_edit && !is_editing"
                    type="button"
                    class="btn onboarding-user-profile-edit-button"
                    aria-label="Edit profile"
                    @click="open_edit"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </div>
              </div>
            </section>

            <section class="onboarding-user-profile-panel cards-border-color">
              <div class="d-flex align-items-center gap-2 mb-4">
                <i class="bi bi-person-fill onboarding-user-profile-panel-icon"></i>
                <div class="fw-bold text-black">Personal Information</div>
              </div>

              <div v-if="save_error" class="alert alert-warning py-2 mb-3">
                {{ save_error }}
              </div>

              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <label class="onboarding-user-profile-label">First Name</label>
                  <input
                    v-if="is_editing"
                    :value="edit_form.first_name"
                    type="text"
                    class="onboarding-user-profile-input"
                    maxlength="50"
                    @input="update_first_name"
                  >
                  <div v-else class="onboarding-user-profile-field">{{ profile.first_name }}</div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="onboarding-user-profile-label">Last Name</label>
                  <input
                    v-if="is_editing"
                    :value="edit_form.last_name"
                    type="text"
                    class="onboarding-user-profile-input"
                    maxlength="50"
                    @input="update_last_name"
                  >
                  <div v-else class="onboarding-user-profile-field">{{ profile.last_name }}</div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="onboarding-user-profile-label">Email Address</label>
                  <div class="onboarding-user-profile-field is-readonly">
                    <span>{{ profile.email }}</span>
                    <i class="bi bi-lock-fill onboarding-user-profile-field-lock" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="onboarding-user-profile-label">Phone Number</label>
                  <input
                    v-if="is_editing"
                    :value="edit_form.phone_number"
                    type="tel"
                    class="onboarding-user-profile-input"
                    maxlength="10"
                    inputmode="numeric"
                    @input="update_phone_number"
                  >
                  <div v-else class="onboarding-user-profile-field">{{ profile.phone_number }}</div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="onboarding-user-profile-label">Date Joined</label>
                  <div class="onboarding-user-profile-field">{{ profile.joined_date }}</div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="onboarding-user-profile-label">Account Status</label>
                  <div class="onboarding-user-profile-field">{{ profile.status_label }}</div>
                </div>
              </div>

              <div v-if="is_editing" class="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2 px-4 py-2"
                  :disabled="is_saving"
                  @click="save_changes"
                >
                  <span
                    v-if="is_saving"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span>{{ is_saving ? 'Saving...' : 'Save Changes' }}</span>
                </button>
              </div>
            </section>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div v-if="visible" class="modal-backdrop fade show onboarding-user-profile-backdrop" @click="close_modal"></div>
</teleport>
